import * as angular from "angular";

export class Oauth2Service {
    private apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/oauth2";
    }

    createApp(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/app", data);
    }

    updateApp(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/app/" + data.oaclid, data);
    }

    authorize(data: any): Promise<object> {
        return this.$http.get(
            this.apiRoot +
                "/authorize/" +
                data.selectedCampaignid +
                "/" +
                data.response_type +
                "/" +
                data.client_id +
                "/" +
                data.state,
            data
        );
    }

    resource(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/resource", data);
    }

    grant(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/grant", data);
    }

    createCampaignApp(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/app/campaign", data);
    }

    createdApps(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/app/created", data);
    }

    authorizedApps(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/app/authorized", data);
    }

    app(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/app", data);
    }

    delete(data: any): Promise<object> {
        return this.$http.delete(
            this.apiRoot + "/app/" + data.id + "/campaign",
            data
        );
    }
}

angular.module("vcServices").service("Oauth2Service", Oauth2Service);
